/**
 * Step 3 of the bulk upload: "We are processing the file..." with a looping progress bar. Two
 * seconds after it mounts it calls `onSubmit` (`BulkUploadModal.tsx`), which posts the rows for
 * validation; the step ends when that request returns.
 */
import React, { useEffect } from "react";
import { Flex } from "@ryerson/frontend.layout";
import styled from "@emotion/styled";
import { Typography } from "@ryerson/frontend.typography";
import { BulkUploadModalText } from "./BulkUploadModalContent";
import { ProgressBar } from "@ryerson/frontend.progress";

/** Props of {@link ProcessingFile}. */
export type ProcessingFileProps = {
	content: BulkUploadModalText;
	onSubmit: () => void;
};

const ProcessingContainer = styled(Flex)`
	width: 100%;
	height: 100%;
	padding-bottom: 60px;
`;

const ProcessingBar = styled(ProgressBar)`
	padding: 0;
`;

/** Step 3: the processing screen; see the file header. */
export const ProcessingFile: React.FC<ProcessingFileProps> = ({ content, onSubmit }) => {
	// The timer is not cleared on unmount. The `onSubmit` it calls is the one from the first
	// render, so it still runs the step-3 branch after the cancel confirmation hides this screen
	// or the modal closes. Each mount starts its own timer.
	useEffect(() => {
		setTimeout(() => {
			onSubmit();
		}, 2000);
	}, []);
	return (
		<ProcessingContainer direction="column">
			<Typography variant="h2">{content.processingFile}</Typography>
			<Typography variant="h2" css={{ marginBottom: "30px" }}>
				{content.pleaseWait}
			</Typography>
			<ProcessingBar loop={true} />
		</ProcessingContainer>
	);
};
